var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 27.5H8.5C7.96957 27.5 7.46086 27.2893 7.08579 26.9142C6.71071 26.5391 6.5 26.0304 6.5 25.5V7.5C6.5 6.96957 6.71071 6.46086 7.08579 6.08579C7.46086 5.71071 7.96957 5.5 8.5 5.5H20.5C21.0304 5.5 21.5391 5.71071 21.9142 6.08579C22.2893 6.46086 22.5 6.96957 22.5 7.5V15.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.861 20.1309C25.6311 19.9052 25.3545 19.7327 25.0507 19.6257C24.7468 19.5186 24.4232 19.4796 24.1026 19.5113C23.782 19.5431 23.4723 19.6449 23.1954 19.8095C22.9185 19.9741 22.6811 20.1975 22.5 20.4639C22.3189 20.1975 22.0815 19.9741 21.8046 19.8095C21.5277 19.6449 21.218 19.5431 20.8974 19.5113C20.5768 19.4796 20.2532 19.5186 19.9493 19.6257C19.6455 19.7327 19.3688 19.9052 19.139 20.1309C18.9367 20.3298 18.776 20.567 18.6663 20.8287C18.5566 21.0903 18.5001 21.3712 18.5001 21.6549C18.5001 21.9387 18.5566 22.2195 18.6663 22.4812C18.776 22.7429 18.9367 22.9801 19.139 23.1789L22.5 26.4999L25.861 23.1789C26.0633 22.9801 26.224 22.7429 26.3337 22.4812C26.4434 22.2195 26.4999 21.9387 26.4999 21.6549C26.4999 21.3712 26.4434 21.0903 26.3337 20.8287C26.224 20.567 26.0633 20.3298 25.861 20.1309V20.1309Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPHeart);
export default __webpack_public_path__ + "static/media/P-heart.dda76008f7b05e459ce72a75aed5fa62.svg";
export { ForwardRef as ReactComponent };